import {
    Flex, SimpleGrid, Text, VStack,
} from '@chakra-ui/react';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { GenericUploadQueueContext } from './context';
import { DocumentUploadItem } from './upload-item';

function GenericDocumentUploadDropzone({
    title,
}: {
    title?: string;
}) {
    const machine = GenericUploadQueueContext.useActorRef();
    const queue = GenericUploadQueueContext.useSelector(
        (state) => state.context.queue
    );
    const onDrop = useCallback((acceptedFiles: File[]) => {
        acceptedFiles.forEach((file) => {
            machine.send({
                type: 'START_UPLOAD',
                file,
            });
        });
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
    } = useDropzone({
        onDrop,
    });

    const dragActiveTitle = isDragActive ? 'Drop files here' : 'Upload and tag any documents related to your properties compliance';

    const dropZoneTitle = (title != null) ? title : dragActiveTitle;
    return (
        <VStack alignItems="start" gap={0}>
            <Flex
                w="full"
                flexDir="column"
                alignItems="center"
                borderRadius="md"
                bgColor="white"
                borderWidth={2}
                borderStyle="dashed"
                borderColor={isDragActive ? 'muted.200' : 'muted.50'}
                py={12}
                px={5}
                cursor="pointer"
                gap={1}
                transition="border-color 0.1s"
                _hover={{
                    borderColor: 'muted.100',
                }}
                mb={queue.length > 0 ? 5 : 0}
                {...getRootProps()}
            >
                <input {...getInputProps()} />
                <Text color={isDragActive ? 'muted.700' : 'muted.500'} fontSize="xmd" fontWeight="medium" textAlign="center">
                    {dropZoneTitle}
                </Text>
                <Text color="muted.200" fontSize="sm" textAlign="center">
                    Drag and drop files here to upload, or click to select
                </Text>
                <Text color="muted.200" fontSize="sm" textAlign="center">
                    Max 200mb. Many file types accepted.
                </Text>
            </Flex>
            <SimpleGrid columns={[1, null, 2, 3]} gap={5} width="100%">
                {queue.map((upload) => (
                    <DocumentUploadItem
                        key={upload.id}
                        actorRef={upload}
                        borderWidth={1}
                        borderColor="muted.50"
                        rounded="md"
                        px={5}
                        py={3}
                        shadow="sm"
                    />
                ))}
            </SimpleGrid>
        </VStack>
    );
}

export { GenericDocumentUploadDropzone };
